import * as React from 'react';
import useHubspotForm from '../../hooks/useHubSpotForm';

import ContactFormStyles from './ContactFormStyles';

export default function GetQuoteForm() {
  useHubspotForm({
    portalId: '5361322',
    formId: '02b2d037-1111-44ee-b2b4-cce017135067',
    target: '#request-quote-form',
  });

  return (
    <ContactFormStyles colorTheme="cyan">
      <div id="request-quote-form" />
    </ContactFormStyles>
  );
}
